import { Routes, Route, BrowserRouter } from "react-router-dom";
import Login from "./pages/loginpage";
import DashboardLayout from "./pages/DashboardLayout";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <Routes>
          <Route
            path="/"
            element={
              localStorage.getItem("token") ? <DashboardLayout /> : <Login />
            }
          />
        </Routes>
        <ToastContainer position="top-left" autoClose={3000} />
      </BrowserRouter>
    </div>
  );
}

export default App;
